export default __webpack_public_path__ + "static/media/ic_fantom_24.b113ecc5.svg";